  import Vue from 'vue'
 import Vuex from 'vuex'
 
 //页面刷新保存状态值不变的引入
// import createVuexAlong from 'vuex-along'
 Vue.use(Vuex)


export default new Vuex.Store({
	state: {
		//定义登录后的返回信息
		userInfo:{
		} ,
		 
	},
	mutations: {
           initUserInfo(state, payload) {
			 //console.log('--------'+payload.userInfo.deptName);
             state.userInfo = payload.userInfo 	 
           } ,
		   clearState(state) {
			 // setNull: (state) => {
			 //   Object.keys(state).forEach(e => {
			 //      state[e] = null
			 //   })
			 
			 // }
			 state.userInfo= null
		   } ,
		   
	},
	actions: {

	},//页面刷新保存状态值不变的配置
	 //plugins: [createVuexAlong()]
})
